module.controller('reportHomeCtrl', [ '$scope', '$q','$rootScope', '$state', 'reportService', 'alertService', 'permissionStatesService','ASEBIOL_CONSTANTS','dateUtilService',reportHomeCtrlFn]);
function reportHomeCtrlFn($scope, $q, $rootScope, $state, ReportService, alertService, stateService, ASEBIOL_CONSTANTS,dateUtil) {
	var vm = $scope;

	//vm.idPlan = $state.params.idPlan;
	//vm.idClient = $state.params.idClient;

	vm.loading = false;
	vm.reports = [];
	vm.reportsFilter = [];
	vm.filter = {};
	vm.options = [{ label: 'Todos', val: 'todo' }, { label: 'Facturado', val: true }, { label: 'No Facturado', val: false }];
	vm.invoiceFilter = vm.options[0];

	vm.number = {};

	vm.datePicker = {};

	vm.reportFilter = {};

	var exit = {};

	var fail = false;

	vm.pagination = {
			current : 1,
			total : 0
	};

	var  wait = null;

	$scope.DATE_FORMAT = ASEBIOL_CONSTANTS.DATE_FORMAT;

	$scope.checkNumber = function(data, report) {

		if (data == '' || data == undefined) {
			return "No puede estar vacio";
		}

		
		return vm.existInvoiceNum(data, report);
		
		
	};

	vm.existInvoiceNum= function(data, report) {
		vm.loading = true;
		var d = $q.defer();
		var filter = {};
		filter.existInvoiceNumber = data;
		ReportService.searchReports(filter).then(function(res) {		
			vm.loading = false;
			res = res || {};

			var responseData = res.getData();
			if(responseData.results.length > 0)
			{
				d.reject('El número ya existe');
			}else{
				 d.resolve();
			}
		}, function(res) {
			vm.loading = false;
			d.reject(' ');
		});
		return d.promise;
	};

	vm.removeNumber = function(invoice, report) {
		alertService.showSwtWarningQuestion('Eliminar número de factura' , function() {
			vm.loading = true;
			var empty = '';
			var idReport = report.id;

			ReportService.removeInvoice(idReport).then(function(response) {
				alertService.showSuccess("Número de factura Eliminado satisfactoriamente");
				report.invoiced = false;
				vm.loading = false;
				report.invoiceNumber = empty;
			}, function(response) {
				vm.loading = false;
			});
		});
	}

	vm.siteFilter = function(report) {
		var sites = [];			
		for (r = 0; r < report.reportsClientSample.length; r++) {
			var siteName = report.reportsClientSample[r].site.name;
			if (sites.indexOf(siteName) == -1) {
				sites.push(siteName);
			}		
		}
		return sites;

	};

	vm.updateInvoice = function(invoice, report) {

		vm.loading = true;
		var idReport = report.id;


		var updateInvoiceModel = {
				
				invoiceNumber : invoice.number
		};

		ReportService.updateInvoice(idReport, updateInvoiceModel).then(function(response) {
			alertService.showSuccess("Numero de factura registrado correctamente");
			report.invoiced = true;
			report.invoiceNumber = invoice.number;
			vm.loading = false;
		}, function(response) {	

			//report.invoiced = true;
			//report.invoiceNumber = '';

			vm.loading = false;
		});
	}




	vm.opcionesQTip = {
			position : {
				my: 'top right',  // Position my top left...
				at: 'bottom right',
				target : 'mouse',
				adjust : {
					x : 5,
					y : 5
				},
			},
			show : {
				delay : 500
			}
	};


	/**
	 * Función que se encarga de consultar los parámetros dado un número de página
	 * @param page
	 */
	vm.search = function(page) {
		vm.loading = true;
		page = page == undefined ? 1 : page;

		vm.pagination.current = page;

		var filter = {};
		filter.offset = (page - 1) * $rootScope.pageSize;
		filter.limit = $rootScope.pageSize;
		

		if(vm.reportFilter.invoiceNumber){
			filter.invoiceNumber = vm.reportFilter.invoiceNumber;
		}

		if(vm.reportFilter.client){
			filter.clientName = vm.reportFilter.client;
		}

//		if (vm.reportFilter.client && vm.reportFilter.client.selected && vm.reportFilter.client.selected.length > 0) {
//			filter.client = $scope.reportFilter.client.selected[0].id;
//		}
		
		if(vm.invoiceFilter.val == true){
			filter.invoiced = true;      	
		}

		if(vm.invoiceFilter.val == false){
			filter.invoiced = false;      	
		}

		// fecha de toma de muestra
		if (!isEmpty(vm.datePicker)) {
			if (vm.datePicker.startDate.isValid() && vm.datePicker.endDate.isValid()) {
				vm.datePicker.startDate.startOf('day');
				vm.datePicker.endDate.endOf('day');
				filter.betweenReportDate = [ dateUtil.datetime2String(vm.datePicker.startDate), dateUtil.datetime2String(vm.datePicker.endDate) ];
			}
		}
		
		filter.state = REPORT_STATE.ACTIVE.enumName;

		ReportService.searchReports(filter).then(function(response) {
			vm.loading = false;

			var responseData = response.getData();
			vm.reports = responseData.results;
			for (i = 0; i < vm.reports.length; i++) {
				responseData.results[i].reportDate = moment(responseData.results[i].reportDate, ASEBIOL_CONSTANTS.DATETIME_FORMAT_MOMENT).toDate();
			}


			var result = response.getData();
			vm.reports = result.results;
			vm.pagination.total = result.totalRegisters;
		}, function(response) {
			vm.loading = false;
		});
	};


	vm.clearFilters = function() {
		vm.reportFilter = {};
		vm.datePicker = {};
		vm.invoiceFilter = {};
		vm.search(1);
	};


	/**
	 * Eventos Datepicker
	 */
	function onApplyDatePicker(ev, picker) {
		vm.search();
	}


	/*
	 * Opciones del datepicker
	 */
	vm.opts = {
			locale : {
				applyClass : 'btn-green',
				applyLabel : "Elegir",
				fromLabel : "desde",
				format : "YYYY-MM-DD",
				toLabel : "a",
				cancelLabel : 'Cancelar',
				customRangeLabel : 'Personalizado'
			},
			ranges : {
				'Sin fecha' : [ '', '' ],
				'Últimos 7 dias' : [ moment().subtract(6, 'days'), moment() ],
				'Últimos 30 dias' : [ moment().subtract(29, 'days'), moment() ],
				'Este mes' : [ moment().startOf('month'), moment().endOf('month') ],
			},
			autoApply : true,
			eventHandlers : {
				'apply.daterangepicker' : onApplyDatePicker
			},
			dateLimit : {
				month : 2
			}
	};

	vm.search(1);

}
